import variables from './anchorVariables.scss';

export const StageAnchorConstants = {
  anchorHandleWidth: parseInt(variables.anchorHandleWidth, 10),
  anchorHandleHeight: parseInt(variables.anchorHandleHeight, 10),
  anchorHandleMarginRight: parseInt(variables.anchorHandleMarginRight, 10),
};
